<label
    class="
        c-form__field
        { !options.label ? 'c-form__field--without-label' : '' }
        { required ? 'c-form__field--required' : '' }
    ">
    <svelte:component
        this="{ InputComponent }"
        {id}
        {required}
        {options}
        {error}
        {touched}
        {value}
        on:change="fire('change', event)"
        on:blur="fire('blur')"
    />
    {#if options.label}
        <span class="c-form__label">{ options.label }</span>
    {/if}
</label>

<script>
    import Text from './Text.html';
    import Email from './Email.html';
    import Textarea from './Textarea.html';

    export default {

        computed: {
            InputComponent: ({ type }) => {
                if(type === 'email') return Email;
                if(type === 'textarea') return Textarea;

                return Text;
            },
        },

    }
</script>